import React from "react";

export default function TestimonialCard() {
  return (
    <section className="py-12 px-4 max-w-4xl mx-auto">
      <div className="bg-white rounded-2xl  shadow-md flex flex-col md:flex-row items-center gap-6">
        {/* Text Section */}
        <div className="flex-1 p-6 md:p-10">
          <p className="text-lg md:text-xl italic text-gray-800 mb-4">
            “Pixell is revolutionary! It’s intuitive tools and hyperlocal
            partners streamline my workflow, helping me to execute my signage
            rollout efficient.”
          </p>
          <div className="flex items-center gap-2">
            <img
              src="/assests/images/LandingPage/testimonialLogo.webp"
              alt="Logo"
              className="h-10 w-auto"
            />
            <div>
              <p className="text-sm font-semibold text-black">Ashwani Arora</p>
              <p className="text-xs text-gray-500">CEO - LT Foods</p>
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="w-64 h-auto shrink-0">
          <img
            src="/assests/images/LandingPage/testimonialCard.webp"
            alt="Ashwani Arora"
            className="rounded-xl object-cover w-full"
          />
        </div>
      </div>
    </section>
  );
}
